import { useMemo } from 'react';
import { useServicesChartsDataContext } from '../../../../Common/Services/hooks/useServicesChartsDataContext';
import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Common/Util/getMonthsByYear';

const useValuePerMonthPerYearTotalChart = () => {
    const { subtitles, chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = useMemo(
        () =>
            [subtitles[0]].map((item) => {
                const data = months.map((month) => {
                    const found = chartData.selectedYear.find(
                        (counter) =>
                            counter.description === item &&
                            parseInt(counter.mes_competencia, 10) ===
                                monthsIndexes[month]
                    );

                    return found ? Number(found.total) : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData, subtitles, months]
    );

    return {
        series,
        subtitles: months
    };
};

export default useValuePerMonthPerYearTotalChart;
